import axiosInstance from "../Interceptors/axiosInstance.jsx";
import Cookies from "js-cookie";

const headers = {
  accept: "*/*",
  Authorization: `Bearer ${Cookies.get("accessToken")}`,
  "Content-Type": "application/json",
};

export const createBlog = async (formValues) => {
  const formData = new FormData();
  formData.append("BlogName", formValues.BlogName);
  formData.append("BlogURL", formValues.BlogURL);
  formData.append("PostedOn", formValues.PostedOn.toString());
  formData.append("PostedBy", formValues.PostedBy);
  formData.append("PageTitle", formValues.PageTitle || "");
  formData.append("MetaDescription", formValues.MetaDescription || "");
  formData.append("Published", formValues.Published.toString());
  formData.append("FullDescription", formValues.FullDescription);
  formData.append("ShortDescription", formValues.ShortDescription);

  if (formValues.ThumbImage) {
    formData.append("ThumbImage", formValues.ThumbImage);
  } else {
    formData.append("ThumbImage", null);
  }

  if (formValues.DetailImage) {
    formData.append("DetailImage", formValues.DetailImage);
  } else {
    formData.append("DetailImage", null);
  }
  const response = await axiosInstance.post("blog", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${Cookies.get("accessToken")}`,
    },
  });
  return response.data;
};
export const updateBlog = async (formValues) => {
  const formData = new FormData();
  formData.append("Id", formValues.Id);
  formData.append("BlogName", formValues.BlogName);
  formData.append("BlogURL", formValues.BlogURL);
  formData.append("PostedOn", formValues.PostedOn.toString());
  formData.append("PostedBy", formValues.PostedBy);
  formData.append("PageTitle", formValues.PageTitle || "");
  formData.append("MetaDescription", formValues.MetaDescription || "");
  formData.append("Published", formValues.Published.toString());
  formData.append("FullDescription", formValues.FullDescription);
  formData.append("ShortDescription", formValues.ShortDescription);

  if (formValues.ThumbImage) {
    formData.append("ThumbImage", formValues.ThumbImage);
  } else {
    formData.append("ThumbImage", null);
  }

  if (formValues.DetailImage) {
    formData.append("DetailImage", formValues.DetailImage);
  } else {
    formData.append("DetailImage", null);
  }

  const response = await axiosInstance.put("blog", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${Cookies.get("accessToken")}`,
    },
  });
  return response.data;
};

export const fetchBlogs = async () => {
  const response = await axiosInstance.get("blog", { headers });
  return response.data;
};

export const fetchBlogById = async (id) => {
  const response = await axiosInstance.get(`blog/${id}`, {
    headers,
  });
  return response.data;
};

export const publishBlog = async (id) => {
  return await await axiosInstance.patch(`blog/${id}/publish`, {
    headers,
  });
};

export const unPublishBlog = async (id) => {
  return await await axiosInstance.patch(`blog/${id}/unpublish`, {
    headers,
  });
};

export const deleteBlog = async (id) => {
  return await axiosInstance.delete(`blog/${id}`, { headers });
};
